import { useApp, useCollection } from '@hb/react'
import {
  Collection,
  getConsentFormsCollection,
  getTemplateCollectionPath,
  Template,
  templateCollections,
  TemplateId,
  TemplateKey,
} from '@hb/shared'
import { useMemo } from 'react'

// currently, only consent form templates are available to practices, and admin templates are not available to practices
export const useTemplateCollection = (practiceId: string | null, type: TemplateKey) => {
  const { appName } = useApp()
  return useMemo(() => {
    if (appName === 'providers-app' && !practiceId) return null
    if (type === 'consentForm') return getConsentFormsCollection(practiceId)
    return practiceId ? null : templateCollections[type]
  }, [practiceId, type, appName])
}
export const useTemplates = (practiceId: string | null, type: TemplateKey) => {
  const adminTemplatesCollection = useTemplateCollection(null, type)
  const practiceCollection = useTemplateCollection(practiceId, type)
  // the practice slot only ever holds a practice-scoped collection — without a practiceId,
  // useTemplateCollection falls back to the admin collection, which would duplicate the
  // admin subscription (and linger as stale items once a practiceId appears)
  const practiceTemplatesCollection = practiceId ? practiceCollection : null
  const adminTemplates = useCollection(adminTemplatesCollection as Collection<Template>)
  const practiceTemplates = useCollection(practiceTemplatesCollection as Collection<Template>)
  return { adminTemplates, practiceTemplates }
}

export const useTemplatesCollectionPath = (type: TemplateKey, templatePracticeId: string | null) =>
  useMemo(() => getTemplateCollectionPath(templatePracticeId, type), [templatePracticeId, type])

export const useTemplateCollectionPath = (type: TemplateKey, templateId: TemplateId | null) =>
  useMemo(() => {
    if (!templateId) return null
    return getTemplateCollectionPath(templateId.practiceId, type)
  }, [templateId, type])
